import React, { useState, useEffect } from "react";
import { Input, Form, Checkbox, Button } from "antd";
import logo from "../../assets/logos/logo.png";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { PASSWORD_VALIDATOR, owntoast } from "../../utils/index";
function Login(props) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Нэвтрэх";
  }, []);

  const handleLogin = (e) => {
    let tmp = {
      name: e.username.toString(),
      pass: e.password,
    };
    setLoading(true);
    props
      .request({ url: `/auth/userlogin`, method: "POST", body: tmp })
      .then((res) => {
        setLoading(false);
        if (res.success) {
          localStorage.setItem("access_token", res.data.access_token);
          localStorage.setItem("auth", JSON.stringify(res.data));
          props.setlogin(true);
          owntoast(res.message, "success");
          if (e.remember) {
            localStorage.setItem("username", e.username);
          } else {
            localStorage.removeItem("username");
          }
          navigate("/");
        } else {
          owntoast(res.message, "error");
        }
      });

    /*  localStorage.setItem("access_token", "123");
    localStorage.setItem("auth", JSON.stringify({ test: "asf" }));
    props.setlogin(true);

    navigate("/"); */
  };
  return (
    <div className="flex items-center h-full justify-center bg-white">
      <div className="bg-white w-full h-full 2xl:w-3/5 2xl:h-4/6 p-8 rounded-md border border-gray-200 drop-shadow-xl">
        <div className="items-center justify-center flex flex-col w-full lg:mr-16 sm:mt-24 lg:mt-0 h-full">
          <img className="w-96 h-16 rounded-md" src={logo} alt="logo" />
          <Form
            className="sm:w-full md:w-80 lg:w-80 xl:w-full mt-4 3xl:mt-12 items-center flex flex-col"
            onFinish={handleLogin}
            initialValues={{
              username: localStorage.getItem("username")
                ? localStorage.getItem("username")
                : "",
              remember: localStorage.getItem("username") ? true : false,
            }}
          >
            <div className="lg:w-80 xl:w-72 w-full">
              <Form.Item
                name="username"
                rules={[{ required: true, message: "Нэвтрэх нэр оруулна уу" }]}
              >
                <Input
                  placeholder="Нэвтрэх нэр"
                  prefix={<UserOutlined style={{ color: "#162654" }} />}
                />
              </Form.Item>
              <Form.Item name="password" rules={PASSWORD_VALIDATOR}>
                <Input.Password
                  placeholder="Нууц үг"
                  prefix={<LockOutlined style={{ color: "#162654" }} />}
                />
              </Form.Item>
              <Form.Item
                className="text-right"
                name="remember"
                valuePropName="checked"
              >
                <Checkbox>Сануулах</Checkbox>
              </Form.Item>
              <Button
                className="bg-primary h-8 w-full flex items-center justify-center text-white "
                type="primary"
                loading={loading}
                htmlType="submit"
              >
                Нэвтрэх
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Login;
